iScreenWizard.factory('crypStorage', function (ISAppHelper) {
	var storage = ISAppHelper.encryptedStorage;
	storage.open = function(){
		var e = "dZunJ?N3dM9Auz$77*2r_R?FDUfT!hmX" + IS.device.getUUID();
		ISAppHelper.encryptedStorage.unlock(e);
	};
	storage.open();
	return ISAppHelper.encryptedStorage;
});
